/*
 * Copyright (c) 2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { Layout, Typography } from 'antd'
import { ReactNode } from 'react'
import { BadgeEnvironment } from '../components/Badge/BadgeEnvironment'
import { BANNER_INFO_RECORD } from '../constants/icons/icons'

interface Props {
  children?: ReactNode
  envTarget?: string
  title?: string
  logoSrc?: string
}

export function CenteredContentLayout({ children, title, logoSrc, envTarget = '' }: Props) {
  return (
    <Layout.Content className="flex h-screen items-center justify-center bg-common-bgLayout">
      <div className="flex flex-col items-center gap-y-4 rounded-lg bg-common-bgBase p-6 md:w-[450px]">
        <BadgeEnvironment bannerInfo={BANNER_INFO_RECORD[envTarget]}>
          <img className="h-[32px]" src={logoSrc} alt="AccelByte Logo" />
        </BadgeEnvironment>
        <Typography.Title level={1} className="!text-2xl font-bold">
          {title}
        </Typography.Title>
        {children}
      </div>
    </Layout.Content>
  )
}
